import { http } from "./client";

export const fetchAnnouncements = () => http.get("Announcements");
export const AnnouncementAdd = (payload) => http.post("Announcements/add", payload);
export const AnnouncementUpdate = (payload) => http.put("Announcements/update", payload);
export const AnnouncementDelete = (payload) => http.delete("Announcements/delete", payload);
